"use client";
import React from "react";
import { Dialog, Disclosure } from "@headlessui/react";
import { Bars3Icon, XMarkIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import PopOver from "./PopOver";
import Image from "next/image";
import { useState } from "react";
import { ThemeSwitch } from "./ThemeChanger";
import Link from "next/link";

const navigation = [
  { name: "Home", href: "/" },
  { name: "FAQ", href: "/FAQ" },
];

const recentNews = [
  { name: "All Articles", href: "/appraisal-news" },
  { name: "Probate Estate Appraisal", href: "/probate-estate-appraisal" },
  { name: "Divorce Appraisal", href: "/divorce-appraisal" },
  { name: "What Is a Home Appraisal?", href: "/appraisal-news/what-is-a-home-appraisal" },
  { name: "Litigation Appraiser", href: "/appraisal-news/litigation-appraiser-real-estate" },
  { name: "Home Appraisal Guide", href: "/appraisal-news/home-appraisal-guide" },
  { name: "Capital Gains Tax", href: "/appraisal-news/capital-gains-tax-appraisal" },
  { name: "Appraisal Fees & Costs", href: "/appraisal-news/home-appraisal-fee-cost" },
];

export default function MobileNav() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <div className="flex lg:hidden">
        <button
          type="button"
          className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5"
          onClick={() => setMobileMenuOpen(true)}
          aria-expanded={mobileMenuOpen}
          aria-controls="mobile-menu"
          aria-label="Open menu"
        >
          <Bars3Icon className="h-6 w-6" aria-hidden="true" />
        </button>
      </div>

      <Dialog
        as="div"
        className="lg:hidden"
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
        id="mobile-menu"
        aria-label="Mobile menu"
      >
        <div className="fixed inset-0 z-50" aria-hidden="true" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white dark:bg-gray-900 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <Link
              href="/"
              className="-m-1.5 p-1.5"
              onClick={() => setMobileMenuOpen(false)}
              aria-label="Home"
            >
              <Image
                className="h-auto w-20"
                height={100}
                width={100}
                src="/logo.png"
                alt="Alpha Appraisals Logo"
                priority
              />
            </Link>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700 dark:text-gray-300"
              onClick={() => setMobileMenuOpen(false)}
              aria-label="Close menu"
            >
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>

          <nav className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-200 dark:divide-gray-700">
              <div className="space-y-1 py-6">
                <PopOver onClose={() => setMobileMenuOpen(false)} />

                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    onClick={() => setMobileMenuOpen(false)}
                    href={item.href}
                    className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 dark:text-white hover:bg-gray-50 dark:hover:bg-gray-800"
                    role="menuitem"
                  >
                    {item.name}
                  </Link>
                ))}

                {/* Recent News Accordion */}
                <Disclosure as="div" className="-mx-3">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center justify-between rounded-lg py-2.5 px-3 text-base font-semibold leading-7 text-gray-900 dark:text-white hover:bg-gray-50 dark:hover:bg-gray-800">
                        Recent News
                        <ChevronDownIcon
                          className={`h-5 w-5 flex-none transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
                          aria-hidden="true"
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="mt-1 space-y-1">
                        {recentNews.map((item) => (
                          <Link
                            key={item.name}
                            href={item.href}
                            onClick={() => setMobileMenuOpen(false)}
                            className="block rounded-lg py-2 pl-6 pr-3 text-sm font-medium text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white"
                          >
                            {item.name}
                          </Link>
                        ))}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>

              </div>

              {/* Bottom section */}
              <div className="py-6 space-y-4">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600 dark:text-gray-400">Theme</span>
                  <ThemeSwitch />
                </div>
                <a
                  href="tel:416-450-2336"
                  className="flex items-center justify-center gap-2 w-full rounded-lg bg-blue-600 px-4 py-3 text-sm font-semibold text-white hover:bg-blue-700 transition-colors"
                >
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  (416) 450-2336
                </a>
              </div>
            </div>
          </nav>
        </Dialog.Panel>
      </Dialog>
    </>
  );
}
